var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "welcome-blocks" },
    _vm._l(_vm.blocks, function(block, bdx) {
      return _c(
        "div",
        {
          key: "block-" + bdx,
          staticClass: "welcome-block",
          class: ["block-" + block.acf_fc_layout]
        },
        [
          block.acf_fc_layout == "tours"
            ? _c("KitTours", { attrs: { block: block } })
            : block.acf_fc_layout == "inspiration"
            ? _c("KitInspiration", { attrs: { block: block } })
            : block.acf_fc_layout == "venues"
            ? _c("KitVenues", { attrs: { block: block } })
            : block.acf_fc_layout == "lodging"
            ? _c("KitLodging", { attrs: { block: block } })
            : block.acf_fc_layout == "events"
            ? _c("KitEvents", { attrs: { block: block } })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/WelcomeKit.vue?vue&type=template&id=5408da32&
// module id = 523
// module chunks = 0